import _ from "lodash";

const backend = window.backend;

export default {
    namespaced: true,
    state: {
        _token: "",
        name: "",
        naming_convention: "",
        type: "",
        description: "",
        purchase_order_numbers: [],
        tags: [],
        budget_amount: "",
        does_track_budget: "",
        quote: null,
        auto_approve: false,
        auto_approve_amount: 500,
        uploadFileType: "source",
        scheduler_enabled: false,
        languages: {
            sourceLanguages: [],
            filesUploading: false,
        },
        selectLanguages: {
            source_language: 64,
            source_language_description: 'English (US)',
            target_languages: [],
            source_languages: [],
            user_language_sets: [],
            account_language_sets: [],
            user_languages: [],
        },
        scheduler: {
            interval_hours: "",
            pickup_from_subfolders: false,
            pick_up_time: "",
            new_order_status: "",
            started_at: "",
            end: "",
            ends_at: "",
            connector_id: "",
            source_folder_id: "",
            source_folder_name: "",
            target_folder_id: "",
            target_folder_name: "",
        },
        deliveryOptions: {
            notify_on_order_submit: true,
            notify_on_new_comment: true,
            notify_on_quote_ready: true,
            notify_on_order_complete: true,
            email_file_done: false,
            emails_to_notify: [],
            connector_delivery_method: "none",
            comment: "",
        },
        behalf_account: auth.usergroup,
        behalf_user: auth.id,
        behalf_accounts_list: [],
        behalf_users_list: [],
        deliveryOptionEmails: [],
    },

    mutations: {
        setToken(state, value) {
            state._token = value;
        },
        setOrderName(state, value) {
            state.name = value;
        },
        setNamingConvention(state, value) {
            state.naming_convention = value;
        },
        setType(state, value) {
            state.type = value;
        },
        setDescription(state, value) {
            state.description = value;
        },
        setPurchaseOrderNumbers(state, value) {
            state.purchase_order_numbers = value;
        },
        setTags(state, value) {
            state.tags = value;
        },
        setBudgetAmount(state, value) {
            state.budget_amount = value;
        },
        setQuote(state, value) {
            state.quote = value;
        },
        setAutoApprove(state, value) {
            state.auto_approve = value;
        },
        setAutoApproveAmount(state, value) {
            state.auto_approve_amount = value;
        },
        setUploadFileType(state, value) {
            state.uploadFileType = value;
        },
        setSchedulerEnabled(state, value) {
            state.scheduler_enabled = value;
        },

        setFilesUploading(state, value) {
            state.languages.filesUploading = value;
        },
        setSourceLanguage(state, value) {
            state.selectLanguages.source_language = value;
        },
        setSourceLanguageDescription(state, value) {
            state.selectLanguages.source_language_description = value;
        },
        setTargetLanguages(state, value) {
            state.selectLanguages.target_languages = value;
        },
        setSchedulerIntervalHours(state, value) {
            state.scheduler.interval_hours = value;
        },
        setSchedulerPickUpTime(state, value) {
            state.scheduler.pick_up_time = value;
        },
        setSchedulerNewOrderStatus(state, value) {
            state.scheduler.new_order_status = value;
        },
        setSchedulerStartedAt(state, value) {
            state.scheduler.started_at = value;
        },
        setSchedulerEnd(state, value) {
            state.scheduler.end = value;
        },
        setSchedulerEndsAt(state, value) {
            state.scheduler.ends_at = value;
        },
        setSchedulerConnectorId(state, value) {
            state.scheduler.connector_id = value;
        },
        setSchedulerSourceFolderId(state, value) {
            state.scheduler.source_folder_id = value;
        },
        setSchedulerSourceFolderName(state, value) {
            state.scheduler.source_folder_name = value;
        },
        setSchedulerTargetFolderId(state, value) {
            state.scheduler.target_folder_id = value;
        },
        setSchedulerTargetFolderName(state, value) {
            state.scheduler.target_folder_name = value;
        },
        setSchedulerPickupFromSubFolders(state, value) {
            state.scheduler.pickup_from_subfolders = value;
        },
        setDeliveryOptionsNotifyOnOrderSubmit(state, value) {
            state.deliveryOptions.notify_on_order_submit = value;
        },
        setDeliveryOptionsNotifyOnNewComment(state, value) {
            state.deliveryOptions.notify_on_new_comment = value;
        },
        setDeliveryOptionsNotifyOnQuoteReady(state, value) {
            state.deliveryOptions.notify_on_quote_ready = value;
        },
        setDeliveryOptionsNotifyOnOrderComplete(state, value) {
            state.deliveryOptions.notify_on_order_complete = value;
        },
        setDeliveryOptionsEmailFileDone(state, value) {
            state.deliveryOptions.email_file_done = value;
        },
        setDeliveryOptionsEmailsToNotify(state, value) {
            state.deliveryOptions.emails_to_notify = value;
        },
        setDeliveryOptionsConnectorDeliveryMethod(state, value) {
            state.deliveryOptions.connector_delivery_method = value;
        },
        setDeliveryOptionsComment(state, value) {
            state.deliveryOptions.comment = value;
        },
        setOnBehalfAccount(state, value) {
            state.behalf_account = value;
        },
        setOnBehalfUser(state, value) {
            state.behalf_user = value;
        },
        setOnBehalfAccountList(state, value) {
            state.behalf_accounts_list = value;
        },
        setOnBehalfUserList(state, value) {
            console.log('setOnBehalfUserList', value)
            state.behalf_users_list = value;
        },
        setUserLanguageSet(state, value) {
            state.selectLanguages.user_language_sets = value;
        },

        setAccountLanguageSets(state, value) {
            state.selectLanguages.account_language_sets = value;
        },

        setSourceLanguages(state, value) {
            state.selectLanguages.source_languages = value;
        },

        setUserLanguages(state, value) {
            state.selectLanguages.user_languages = value;
        },
        setDeliveryOption(state, payload) {
            let {option, value} = payload;

            state.deliveryOptions[option] = value;
        },
        setDoesTrackBudget(state, value) {
            state.does_track_budget = value;
        },
        setDeliveryEmailOptions(state, value) {
            state.deliveryOptionEmails = value;
        },
        updateDeliveryEmailOptions(state, value) {
            state.deliveryOptionEmails.push(value);
        },
    },
    getters: {
        toApiFormat(state) {
            return {
                _token: state._token,
                name: state.name,
                naming_convention: state.naming_convention,
                purchase_order_numbers: state.purchase_order_numbers,
                type: state.type,
                tags: state.tags,
                description: state.description,
                budget_amount: state.budget_amount,
                auto_approve: state.auto_approve,
                auto_approve_amount: state.auto_approve_amount,
                quote: state.quote,
                does_track_budget: state.does_track_budget,
                scheduler_enabled: state.scheduler_enabled,
                scheduler: {
                    interval_hours: state.scheduler.interval_hours,
                    pick_up_time: state.scheduler.pick_up_time,
                    new_order_status: state.scheduler.new_order_status,
                    started_at: state.scheduler.started_at,
                    end: state.scheduler.end,
                    ends_at: state.scheduler.ends_at,
                    connector_id: state.scheduler.connector_id,
                    source_folder_id: state.scheduler.source_folder_id,
                    source_folder_name: state.scheduler.source_folder_name,
                    target_folder_id: state.scheduler.target_folder_id,
                    target_folder_name: state.scheduler.target_folder_name,
                },
                source_language: state.selectLanguages.source_language,
                "source-language": state.selectLanguages.source_language,
                target_languages: state.selectLanguages.target_languages?.map(lang => lang.id),
                notify_on_order_submit: state.deliveryOptions.notify_on_order_submit,
                notify_on_new_comment: state.deliveryOptions.notify_on_new_comment,
                notify_on_quote_ready: state.deliveryOptions.notify_on_quote_ready,
                notify_on_order_complete: state.deliveryOptions.notify_on_order_complete,
                emails_to_notify: state.deliveryOptions.emails_to_notify,
                connector_delivery_method: state.deliveryOptions.connector_delivery_method,
                comment: state.deliveryOptions.comment,
                behalf_account: state.behalf_account,
                behalf_user: state.behalf_user,
                behalf_accounts_list: state.behalf_accounts_list,
                behalf_users_list: state.behalf_users_list,
            };
        },
        userLanguageSets: (state) => {
            return state.selectLanguages.user_language_sets;
        },

        userLanguages: (state) => {
            return state.selectLanguages.user_languages;
        },
    },
    actions: {
        updateOrderName({commit}, value) {
            commit("setOrderName", value);
        },

        updateSourceLanguage({state, commit, getters, rootGetters}, value) {
            commit("setSourceLanguage", value);
        },

        updateSourceLanguageDescription(
            {state, commit, getters, rootGetters},
            value
        ) {
            commit("setSourceLanguageDescription", value);
        },

        updateDeliveryOption({state, commit, getters, rootGetters}, payload) {
            commit("setDeliveryOption", payload);
        },

        updateConnectorDeliveryMethod(
            {state, commit, getters, rootGetters},
            value
        ) {
            commit("setConnectorDeliveryMethod", value);
        },

        updateTargetLanguages({state, commit, getters, rootGetters}, value) {
            commit("setTargetLanguages", value);
        },

        updatecomment({state, commit, getters, rootGetters}, value) {
            commit("setComment", value);
        },
        onNotifyEmail({state, commit, getters, rootGetters}, value) {
            if (validateEmail(value)) {
                commit("addNotifyEmail", value);
            }
        },

        getUserLanguageSets({state, commit, getters, rootGetters}, userId) {
            let sourceLanguage = state.selectLanguages.source_language;

            return axios
                .get(`/languages/sets/${userId}/source/${sourceLanguage}`)
                .then((result) => {
                    const {data} = result.data;

                    commit("setUserLanguageSet", data);

                    return data;
                });
        },
        updateBehalfAccountList({commit}, value) {
            commit("setOnBehalfAccountList", value);
        },
        updateOnBehalfUserList({commit}, value) {
            commit("setOnBehalfUserList", value);
        },
        getAccountLanguageSets({state, commit, getters, rootGetters}, id) {
            let sourceLanguage = state.selectLanguages.source_language;

            return axios
                .get(`/languages/sets/accounts/${id}/source/${sourceLanguage}`)
                .then((result) => {
                    const {data} = result.data;

                    commit("setAccountLanguageSets", data);

                    return data;
                });
        },
        /**
         * Get all users available languages
         *
         */
        getTargetLanguages({state, commit, getters, rootGetters}, id) {
            let sourceLanguage = state.selectLanguages.source_language;

            return axios(`/languages/all/${sourceLanguage}`).then((result) => {
                const {data} = result;

                commit("setUserLanguages", data);

                //@TODO - Rename this to make more clear
                return data;
            });
        },

        /**
         * Load the users source langauges
         *
         */
        getSourceLanguages({state, commit, getters, rootGetters}, value) {
            return axios(`/languages/sources`).then((result) => {
                const {data} = result.data;
                commit("setSourceLanguages", data);

                //@TODO - Rename this to make more clear
                return data;
            });
        },

        activateProgram({state, commit, getters, rootGetters}, value) {
            // post data to route
            return axios
                .post(`/programs`, getters.toApiFormat)
                .then((result) => {
                    const {program_id} = result.data;
                    window.location.href = `/programs/${program_id}`;
                    return data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
